export enum DocumentInformationInterationType {
  VISUALIZATIONAUTH = 'VISUALIZATIONAUTH',
  VISUALIZATIONANONYMOUS = 'VISUALIZATIONANONYMOUS',
  DOWNLOADAUTH = 'DOWNLOADAUTH',
}
